import { useState } from "react";
import styles from "./LandingPageAccordion.module.scss";

interface AccordionItem {
	id: string;
	question: string;
	answer: string;
}

interface AccordionProps {
	items: AccordionItem[];
}

export default function LandingPageAccordion({ items }: AccordionProps) {
	const [openItems, setOpenItems] = useState<Set<string>>(new Set());

	const toggleItem = (id: string) => {
		setOpenItems(prev => {
			const newSet = new Set(prev);
			if (newSet.has(id)) {
				newSet.delete(id);
			} else {
				newSet.add(id);
			}
			return newSet;
		});
	};

	return (
		<div className={styles.accordion}>
			{items.map(item => {
				const isOpen = openItems.has(item.id);

				return (
					<div key={item.id} className={styles.accordionItem}>
						<button className={styles.accordionHeader} onClick={() => toggleItem(item.id)} aria-expanded={isOpen}>
							<span className={styles.question}>{item.question}</span>
							<span className={`${styles.icon} ${isOpen ? styles.iconOpen : ""}`}>
								<span className={styles.iconLine}></span>
								<span className={styles.iconLine}></span>
							</span>
						</button>

						<div className={`${styles.accordionContent} ${isOpen ? styles.accordionContentOpen : ""}`}>
							<div className={styles.accordionBody}>
								<p>{item.answer}</p>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}
